import React, { useContext, useEffect, useState } from "react";
import MobileNavMenus from "@/app/(general-header)/header/mobileNavMenus";
import MobileTopNavCta from "@/app/(general-header)/header/mobileTopNavCta";
import {
  AccountNav,
  AccountValidation,
  BotBPass,
  HeaderData,
  MobileTopNavCTA,
  UserMenus,
} from "@/app/(general-header)/header/types";
import Logout from "@/app/(general-header)/header/logout";
import MyAccountNav from "@/app/(general-header)/header/my-account-nav";
import BotBPassNavMenu from "@/app/(general-header)/header/botbPassNavMenu";
import AllCompetitions from "@/app/(general-header)/header/allCompetitions";
import FeaturedCompetitionsNew from "@/app/(general-header)/header/featuredCompetitionsNew";
import SpinAWheelNavMenuItemNew from "@/app/(general-header)/header/spinAWheelNavMenuItemNew";
import UserInfo from "@/app/(general-header)/header/userInfo";
import BlackFridayLeaderBoardNavMenu from "@/app/(general-header)/header/blackFridayLeaderBoardNavMenu";
import SubscriberCompetitionsWidget from "@/app/(general-header)/header/SubscriberCompetitionsWidget";
import LeaderboardChristmasBadge from "@/app/(general-header)/header/leaderboardChristmasBadge";
import ChristmasRaffleNavMenu from "@/app/(general-header)/header/christmasRaffleNavMenu";
import CountdownTimer from "../../components/Countdown/countdown";
import FeaturedSubscriberCompetitions from "@/app/(general-header)/header/featuredSubscriberCompetitions";
import { useCompetition, useCompetitionByType } from "@/app/redux/features/categories/selectors";
import { setActiveCompetitions } from "@/app/redux/features/categories/actions";
import { getHeaderData } from "@/app/(general-header)/header/header-service";
import { setFeaturedImage } from "@/app/redux/features/categories/slice";
import { publishUserData, setHeaderIsLoading, setIsRafEnabled } from "@/app/redux/features/header/headerSlice";
import { useAppDispatch } from "@/app/redux/hooks";
import { useUserData } from "@/app/(general-header)/header/hooks";
import PastDueNotification from "@/app/(general-header)/header/pastDueNotification";
import { useIsMobile } from "@/app/redux/features/device/selectors";
import EnterNowButton from "@/app/(custom-header)/prizes/house-v2/EnterNowButton";
import { HouseCompetitionData } from "@/app/(custom-header)/prizes/house-v2/contextProvider";

type MobileHeaderProps = {
  botbPassNavMenu: BotBPass;
  topNavCTA: MobileTopNavCTA;
  userData: UserMenus;
  accountValidationContent: AccountValidation;
  accountNavData: AccountNav[];
  isBotBPassHeader: boolean;
  isFounderPage?: boolean;
  isLeaderBoardPage?: boolean;
  isLeaderBoardChristmasPage?: boolean;
  milestoneData: string;
  blackFridayLeaderboardNavMenu?: boolean;
  IsRAFEnabled?: boolean;
};

const isRAFActive = false;

const CustomHeaderV3 = () => {
  const [header, setHeader] = useState<HeaderData>();
  const [isLoading, setIsLoading] = useState(true);
  const isMobile = useIsMobile();

  const dispatch = useAppDispatch();
  const [isMobileNavMenusVisible, setIsMobileNavMenusVisible] = useState(false); //TEMP on TRUE
  const userData = useUserData();

  const [carouselWasScrolled, setCarouselWasScrolled] = useState(false);

  useEffect(() => {
    const activeCompetitionsPromise = dispatch(setActiveCompetitions());
    activeCompetitionsPromise
      .unwrap()
      .then(res => {
        const syncEvent = new CustomEvent("sync-header-store", {
          detail: res,
        });
        window.dispatchEvent(syncEvent);
      })
      .catch(err => console.error(err));

    return () => {
      activeCompetitionsPromise.abort();
    };
  }, []);

  const fetchHeader = async () => {
    try {
      const response = await getHeaderData();
      const headerData = (await response.json()) as HeaderData;
      dispatch(setFeaturedImage(headerData.featuredCategoryImage));
      dispatch(setIsRafEnabled(headerData.IsRAFEnabled));
      const syncStoresEvent = new CustomEvent("sync-second-store", {
        detail: headerData,
      });
      window.dispatchEvent(syncStoresEvent);
      setHeader(headerData);
      dispatch(publishUserData({ userData: headerData?.MyAccountMenuBar }));
    } catch (err) {
      console.log(`Error while fetching the header data - ${JSON.stringify(err)}`);
    } finally {
      setIsLoading(false);
      dispatch(setHeaderIsLoading(false));
    }
  };

  useEffect(() => {
    fetchHeader();
  }, []);

  const now = new Date();
  const targetDate = new Date("2025-12-31T23:59:59");
  const timezoneOffset = new Date().getTimezoneOffset() * 60000;
  const englandTargetDate = new Date(targetDate.getTime() - timezoneOffset);
  const targetDateChristmasDraws = new Date("2026-01-02T20:58:59");
  const englandTargetDateChristmasDraws = new Date(targetDateChristmasDraws.getTime() - timezoneOffset);
  const isDecember = englandTargetDate.getTime() - now.getTime() > 0;
  const isJanuary = englandTargetDateChristmasDraws.getTime() - now.getTime() > 0;

  const subscriberCategory = useCompetitionByType("subscriberCompetitions");

  const { competitionState } = useContext(HouseCompetitionData);

  const openMobileNavMenus = () => (
    <div className="fixed top-0 left-0 bottom-0 right-0 bg-[rgba(0,0,0,0.7)] z-[1002]">
      <div className="absolute xs:w-full md:w-1/2 h-full p-3 bg-[#f5f5f5] overflow-y-auto z-10 pb-[38px]">
        <svg
          onClick={() => setIsMobileNavMenusVisible(false)}
          className="cursor-pointer fixed top-[12px] left-[7px] z-20"
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <circle cx="16" cy="16" r="16" fill="white"></circle>
          <path
            d="M22 10L10 22M10 10L22 22"
            stroke="#898994"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"></path>
        </svg>
        <div className="flex flex-col gap-8 mt-[46px]">
          {userData?.IsAuthenticated && <UserInfo userData={userData} />}

          {header?.BotBPassNav && <BotBPassNavMenu navMenuData={header.BotBPassNav} />}
          {isRAFActive && <LeaderboardChristmasBadge isPlacedInMenu={true} IsRAFEnabled={header?.IsRAFEnabled} />}

          {subscriberCategory ? <FeaturedSubscriberCompetitions /> : null}

          <FeaturedCompetitionsNew />

          {/*<FeelingLuckySection />*/}

          {(isDecember || isJanuary) && (
            <div>
              <div className="text-gray-1 font-jost text-xs font-medium leading-4 lg:text-sm lg:leading-5">
                A DECEMBER TO REMEMBER
              </div>
              {isDecember && <BlackFridayLeaderBoardNavMenu />}
              {isJanuary && <ChristmasRaffleNavMenu />}
              <SubscriberCompetitionsWidget />
            </div>
          )}

          <AllCompetitions />

          <SpinAWheelNavMenuItemNew userData={userData} />

          <MobileNavMenus userData={userData} accountValidationContent={header?.AccountValidationContent} />
          <MyAccountNav accountNavData={header?.MyAccountNav} />
          <MobileTopNavCta {...header?.TopNavCta} />
          {userData?.IsAuthenticated && <Logout />}
        </div>
      </div>
    </div>
  );

  const getBurgerMenu = () => (
    <svg
      className="cursor-pointer"
      onClick={() => setIsMobileNavMenusVisible(true)}
      width="28"
      height="29"
      viewBox="0 0 28 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.66675 7.46143H23.3334M4.66675 14.4614H23.3334M4.66675 21.4614H23.3334"
        stroke="#4C4C52"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"></path>
    </svg>
  );

  const getBackButton = () => (
    <svg
      className="cursor-pointer"
      onClick={() => history.go(-1)}
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="29"
      viewBox="0 0 28 29"
      fill="none">
      <path
        d="M6.66602 16H25.3327M6.66602 16L14.666 24M6.66602 16L14.666 8"
        stroke="#4C4C52"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  useEffect(() => {
    const onMoveButtonUp = event => {
      if (!event.detail) {
        setCarouselWasScrolled(true);
      } else {
        setCarouselWasScrolled(false);
      }
    };
    window.addEventListener("moveButtonUp", onMoveButtonUp);

    return () => {
      window.removeEventListener("moveButtonUp", onMoveButtonUp);
    };
  }, []);

  const houseCompetition = useCompetition({
    CompetitionTypePrefix: "HC",
  });

  return (
    <>
      <header className={"lg:sticky top-0 bg-white z-[1002] border-b-[#E0E0E0] border-b border-solid"}>
        <div
          className={`flex items-center justify-between h-[57px] px-3 lg:h-[60px] lg:px-6 relative mainSection mx-auto border-none`}>
          <div>{isMobile ? getBurgerMenu() : getBackButton()}</div>
          <img
            src="/assets/images/house-competition/house-header-badge.png"
            alt="house badge"
            className="w-[90px] lg:w-[120px] top-4 absolute left-1/2 -translate-x-1/2 z-[1]"
          />
          {!isMobile && (
            <div className={"font-jost flex items-center gap-4 grow justify-end"}>
              <div id={"top_counter"}>
                <div className={"text-secondary text-base leading-5.5 font-normal tracking-tight mb-0.5"}>
                  {houseCompetition.SubtitleText || houseCompetition.Title}
                  {/*LAST CHANCE! Win the keys to a £1.25M Essex home for £1!*/}
                </div>
                <CountdownTimer
                  EndDateTime={new Date(houseCompetition.EndDateTime)}
                  textClass={"uppercase text-secondary text-base leading-5.5 font-normal mr-1"}
                  numericClass={"text-secondary font-bold text-base leading-5.5"}
                  containerClass={"flex items-center gap-[2px] leading-none"}
                  format="d:h:m:s"
                />
              </div>
              <div
                className={`overflow-hidden transition-[width] duration-700 ease-in-out`}
                style={{ width: carouselWasScrolled ? "160px" : "0" }}>
                {carouselWasScrolled && <EnterNowButton variation={"desktop_sticky"} place="house_new_floating_cta" />}
              </div>
            </div>
          )}
        </div>
      </header>
      {header?.ShowPastDueBanner ? <PastDueNotification onSnooze={fetchHeader} /> : null}
      {isMobileNavMenusVisible && openMobileNavMenus()}
    </>
  );
};

export default CustomHeaderV3;
